import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignCalendarHolidaysToResource(
    request: Boundaries["assignCalendarHolidaysToResource"]["request"],
  ): void;
}

function useAssignCalendarHolidaysToResource(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignCalendarHolidaysToResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignCalendarHolidaysToResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignCalendarHolidaysToResourceRequestFailure(resource),
    ),
    assignCalendarHolidaysToResource: core.assignCalendarHolidaysToResource,
  };
}

export { useAssignCalendarHolidaysToResource };
